import { computed, type ComputedRef } from 'vue';
import type { RouteLocationRaw } from 'vue-router';
import {
  ORGANIZATION_TAG_ROUTE_NAMES,
  resolveOrganizationTagVariant,
} from '@/routers/designRoutes';
import { useIsNextLayout } from '@/utils/composables/useLayoutVariant';
import { useMenuSection } from '@/utils/composables/useMenuSection';
import { useIsAdmin } from '@/utils/user';

/** 組織タグ画面のルート。デザインとセクションでルート名が違うので、現在の画面から解決する */
export const useOrganizationTagRoute = (): {
  listRoute: ComputedRef<RouteLocationRaw>;
  detailRoute: (organizationTagId: number) => RouteLocationRaw;
} => {
  const section = useMenuSection();
  const isNextLayout = useIsNextLayout();
  const { isAdmin } = useIsAdmin();

  const routeNames = computed(
    () =>
      ORGANIZATION_TAG_ROUTE_NAMES[
        resolveOrganizationTagVariant({
          isNextLayout,
          section: section.value,
          isAdminUser: isAdmin.value,
        })
      ],
  );

  return {
    listRoute: computed(() => ({ name: routeNames.value.list })),
    detailRoute: (organizationTagId: number) => ({
      name: routeNames.value.detail,
      params: { organizationTagId },
    }),
  };
};
